import { Component, Input, Inject, OnInit } from '@angular/core';

import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";
import { GroupService } from '../../../../admin/services/group.service';
import { Observable } from 'rxjs';
import { GroupStub } from '../../../../admin/models/group.model';
import { first } from 'rxjs/operators';

@Component({
    selector: 'side-effect-create-contact',
    templateUrl: './side-effect-create-contact.component.html',
    standalone: false
})
export class SideEffectCreateContactComponent implements OnInit {
    _seConfiguration: any;
    availableGroups = new Array<GroupStub>();

    set seConfiguration(value: any) {
        this._seConfiguration = value ||{};
        this._seConfiguration.organizationId = this._seConfiguration.organizationId||''; 
        this._seConfiguration.firstName = this._seConfiguration.firstName || '';
        this._seConfiguration.middleInitial = this._seConfiguration.middleInitial || ''; 
        this._seConfiguration.lastName = this._seConfiguration.lastName || '';
        this._seConfiguration.entityOrOrganizationName = this._seConfiguration.entityOrOrganizationName || '';
        this._seConfiguration.isEntityOrOrganization = this._seConfiguration.isEntityOrOrganization || '';
        this._seConfiguration.suffix = this._seConfiguration.suffix || ''; 
        this._seConfiguration.fullLegalName = this._seConfiguration.fullLegalName||''; 
        this._seConfiguration.emailAddress = this._seConfiguration.emailAddress||''; 
        this._seConfiguration.userName = this._seConfiguration.userName||''; 
        this._seConfiguration.primaryPhone = this._seConfiguration.primaryPhone||''; 
        this._seConfiguration.secondaryPhone = this._seConfiguration.secondaryPhone||''; 
        this._seConfiguration.fax = this._seConfiguration.fax||''; 
        this._seConfiguration.street = this._seConfiguration.street||''; 
        this._seConfiguration.suite = this._seConfiguration.suite||''; 
        this._seConfiguration.poBox = this._seConfiguration.poBox||''; 
        this._seConfiguration.city = this._seConfiguration.city||''; 
        this._seConfiguration.stateCode = this._seConfiguration.stateCode||''; 
        this._seConfiguration.zipCode = this._seConfiguration.zipCode||''; 
        this._seConfiguration.internalContact = this._seConfiguration.internalContact||''; 
        this._seConfiguration.agentType = this._seConfiguration.agentType||''; 
        this._seConfiguration.userIdTarget = this._seConfiguration.userIdTarget || '';
        this._seConfiguration.isUserTarget = this._seConfiguration.isUserTarget || '';
        this._seConfiguration.groupIdToAssignUserTo = this._seConfiguration.groupIdToAssignUserTo || '';
        this._seConfiguration.canLogin = this._seConfiguration.canLogin || '';
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }
    
    constructor(
        public readonly groupService: GroupService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }

    ngOnInit() {
        this.getAvailableGroups();
    }

    getAvailableGroups(): void {
        this.availableGroups.push({ id: "-1", displayName: "..." });
        (this.groupService.get({ stubs: true, internal: false }) as Observable<GroupStub[]>).pipe(
            first())
            .subscribe(groups => {
                this.availableGroups = this.availableGroups.concat(groups);
            });
    }
}
